import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { PieChart, Pie, Cell, ResponsiveContainer, Legend, Tooltip } from "recharts";

const COLORS = [
  'hsl(221.2, 83.2%, 53.3%)',
  'hsl(142.1, 76.2%, 36.3%)',
  'hsl(0, 84.2%, 60.2%)',
  'hsl(43, 74%, 66%)',
  'hsl(27, 87%, 67%)',
  'hsl(280, 60%, 55%)',
  'hsl(180, 60%, 40%)'
];

function AssetAllocationChart({ summary, currency }) {
  const data = summary?.asset_allocation || [];

  return (
    <Card data-testid="asset-allocation-chart" className="border border-border">
      <CardHeader>
        <CardTitle className="text-xl sm:text-2xl tracking-tight font-semibold">
          Asset Allocation
        </CardTitle>
      </CardHeader>
      <CardContent className="p-6 h-full">
        {data.length > 0 ? (
          <ResponsiveContainer width="100%" height={300}>
            <PieChart>
              <Pie
                data={data}
                cx="50%"
                cy="50%"
                labelLine={false}
                label={({ name, percent }) => `${name} (${(percent * 100).toFixed(0)}%)`}
                outerRadius={90}
                dataKey="value"
              >
                {data.map((entry, index) => (
                  <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                ))}
              </Pie>
              <Tooltip formatter={(value) => `${currency} ${value.toFixed(2)}`} />
              <Legend />
            </PieChart>
          </ResponsiveContainer>
        ) : (
          <div className="h-[300px] flex items-center justify-center text-muted-foreground text-sm">
            No holdings yet. Add an investment transaction to see allocation.
          </div>
        )}
      </CardContent>
    </Card>
  );
}

export default AssetAllocationChart;
